import { AutogenLayoutEdiChangeFieldAdd } from "./autogen/AutogenLayoutEdiChangeFieldAdd";
import {  Label, TableRowDisplayEvent, Textbox, SelectionType, Button } from "@mcleod/components";

export class EdiChangeFieldAdd extends AutogenLayoutEdiChangeFieldAdd {

    private _saveButton = new Button({
        id: "",
        caption: "Save & Close",
        backgroundColor: "primary",
        color: "primary.reverse",
        minWidth: 128,
        borderWidth: 0,
        rowBreak: false,
        enabled: true,
        tooltip: "Saves selcted fields to the EDI Change",
    });
    public get saveButton() {
        return this._saveButton;
    }
    public set saveButton(value) {
        this._saveButton = value;
    }

/** This is an event handler for the onRowDisplay event of tableChangeFieldInfo. */
  tableChangeFieldInfoOnRowDisplay(event: TableRowDisplayEvent) {
    const row = event.getTableRow();

    const labelDataType = row.findComponentById("labelDataType") as Label;

    if(labelDataType){
        const dataType = row.data.get("data_type");
        const dataLength = row.data.get("data_length");
        const decimalPrecision = row.data.get("decimal_precision");

        let labelText = dataType || "";

        // Check if it's a decimal type
        if (dataType && dataType.toLowerCase().includes("decimal")) {
            // For decimal types, include length and decimal_precision in parentheses
            if (dataLength !== null && dataLength !== undefined &&
                decimalPrecision !== null && decimalPrecision !== undefined) {
                labelText += `(${dataLength},${decimalPrecision})`;
            } else if (dataLength !== null && dataLength !== undefined) {
                labelText += `(${dataLength})`;
            }
        } else {
            // For non-decimal types, include only length if present
            if (dataLength !== null && dataLength !== undefined) {
                labelText += `(${dataLength})`;
            }
        }

        labelDataType.text = labelText;
    }
  }

  /**
   * Loops through sourceEdiChangeField rows and selects/checks matching rows
   * in tableChangeFieldInfo based on field_name criteria
   */
  public selectMatchingFields(): void {
    if (!this.sourceEdiChangeField || !this.tableChangeFieldInfo) {
      return;
    }

    // Get all rows from sourceEdiChangeField
    const sourceRows = this.sourceEdiChangeField.data;

    // Get all rows from tableChangeFieldInfo
    const tableRows = this.tableChangeFieldInfo.allRows;

    // Loop through source rows to find field names to match
    sourceRows.forEach(sourceRow => {
      const sourceFieldName = sourceRow.get("field_name");

      if (sourceFieldName) {
        // Find matching row in tableChangeFieldInfo
        const matchingTableRow = tableRows.find(tableRow => {
          const tableFieldName = tableRow.data.get("field_name");
          return tableFieldName === sourceFieldName;
        });

        // Select/check the matching row if found
        if (matchingTableRow) {
          this.tableChangeFieldInfo.selectRow(matchingTableRow, SelectionType.DISTINCT, null);
        }
      }
    });
  }

}
